import { gql } from "@apollo/client";

export const GENERAR_CONFORMIDADES = gql`
mutation GenerarConformidades($input: AddConformidadesInput!) {
  generarConformidades(input: $input) {
    success
    error
    valorEsperado
  }
}
`;